import { eChannelType } from 'src/providers/SocketsProvider/Sockets.enums';

export function isTikTokChannel(channel: string | undefined): boolean {
  return channel === eChannelType.TIKTOK;
}

export function isMessengerChannel(channel: string | undefined): boolean {
  return channel === eChannelType.MESSENGER;
}

export function isInstagramChannel(channel: string | undefined): boolean {
  return channel === eChannelType.INSTAGRAM;
}

export const integrationIcons: Record<eChannelType, string> = {
  [eChannelType.WHATSAPP_WEB]: '/images/icons/whatsapp-icon.png',
  [eChannelType.WHATSAPP_API]: '/images/icons/whatsapp-business-icon.png',
  [eChannelType.MESSENGER]: '/images/icons/messenger-icon.png',
  [eChannelType.INSTAGRAM]: '/images/icons/instagram-icon.png',
  [eChannelType.TIKTOK]: '/images/icons/tiktok-icon.png',
};

export const integrationNames: Record<eChannelType, string> = {
  [eChannelType.WHATSAPP_WEB]: 'WhatsApp',
  [eChannelType.WHATSAPP_API]: 'WhatsApp Business',
  [eChannelType.MESSENGER]: 'Messenger',
  [eChannelType.INSTAGRAM]: 'Instagram',
  [eChannelType.TIKTOK]: 'TikTok',
};

// Channel theme tokens (--bubble-bg, --bubble-text, --bubble-accent) are defined
// as CSS custom properties on [data-channel] selectors in MessageContainer.styles.scss.
// Adding a new channel requires one CSS block there — zero JS changes.
